import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
    faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload,faUserSecret, faPlus,
    faInfo, faEdit, faTrophy, faHandshake, faTrashAlt, faTimesCircle, faClone, 
    faTruckLoading, faUserPlus, faBoxes, faMedkit, faPray, faUserNinja, faFistRaised, faJournalWhills, faHeartBroken,
    faDiceOne, faDiceTwo, faDiceThree, faDiceFour, faDiceFive, faDiceSix, faDice, faSkull, faSkullCrossbones, faAward, faLongArrowAltRight,
    faThumbsDown, faThumbsUp, faGrinStars, faGrimace, faUserMinus,
} from "@fortawesome/free-solid-svg-icons";
import { faIdCard, faIdBadge, } from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
    faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload, faUserSecret, faPlus, 
    faInfo, faEdit, faTrophy, faHandshake, faTrashAlt, faTimesCircle, faClone, faIdCard, faIdBadge,
    faTruckLoading, faUserPlus, faBoxes, faMedkit, faPray, faUserNinja, faFistRaised, faJournalWhills, faHeartBroken,
    faDiceOne, faDiceTwo, faDiceThree, faDiceFour, faDiceFive, faDiceSix, faDice, faSkull, faSkullCrossbones, faAward, faLongArrowAltRight,
    faThumbsDown, faThumbsUp, faGrinStars, faGrimace, faUserMinus,
);

Vue.component('font-awesome-icon', FontAwesomeIcon)

